<template lang='pug'>
  v-container(fluid)
    v-skeleton-loader.mx-auto(v-if="!item" max-width="500" type="card")
</template>
<script>
  // import axios from 'axios'
  import loaders from '@/plugins/mixins/loaders'
  import Swal from 'sweetalert2'
  const formatter = new Intl.NumberFormat('es-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    minimumIntegerDigits: 1,
  })
  export default {

    filters: {
      moneyFormat: function (value) {
        const entero = value.toString().slice(0, -2)
        const decimal = value.toString().slice(-2)
        return formatter.format(entero.concat('.', decimal))
      },
    },

    components: {
    },

    mixins: [loaders],

    data: () => ({
      item: '',
    }),

    created () {
      const vm = this
      // console.log(vm.$route.params.code)
      if (vm.$route.params.code === 'success') {
        Swal.fire({
          icon: 'success',
          title: 'Afiliado a mercadopago exitosamente!',
          confirmButtonText: 'Ok',
        }).then((result) => {
          vm.$router.replace('/dashboard/profile')
        })
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Ocurrio un error. Por favor Intente nuevamente si persiste el error comuniquese con soporte. ',
          confirmButtonText: 'Ok',
        }).then((result) => {
          vm.$router.replace('/dashboard/profile')
        })
      }
    },

    methods: {
    },
  }
</script>
